<template>
    <div class="container mx-auto py-8">
        <!-- Page Title -->
        <h1 class="text-5xl font-bold mb-6 text-green-900">Members</h1>
        <p class="pb-3">Meet the members</p>
        <router-link to="/member-register" target="_blank"
            class="bg-gradient-to-r from-green-900 to-green-800 text-white px-6 py-4 mt-4 mb-8 rounded-full text-lg shadow-lg hover:scale-105 transform transition">
            + Register as a Member
        </router-link>

        <!-- Dynamic Tab Navigation -->
        <div class="flex justify-center mb-8 mt-6">
            <button v-for="(group, index) in memberGroups" :key="index" :class="[
                'px-6 py-2 text-xl font-semibold my-2',
                activeTab === group ? 'text-green-900 border-b-2 border-green-900' : 'text-gray-600',
            ]" @click="activeTab = group" style="text-decoration: none;">
                {{ group }}
            </button>
        </div>

        <!-- Dynamic Member Sections -->
        <section v-if="activeTab" class="mb-10">
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
                <div v-for="(member, index) in members[activeTab]" :key="index"
                    class="member-card group border pt-3 pb-3 relative">
                    <img :src="`${this.$root.$data.BASE_URL}/members/images/${member.profile_pic}`" alt="Member Image"
                        class="w-36 h-36 object-cover rounded-full mx-auto" />
                    <div class="text-center mt-4">
                        <h3 class="text-xl font-semibold">{{ member.name }}</h3>
                        <p class="text-sm text-gray-600">{{ member.member_code }}</p>
                    </div>
                    <div
                        class="absolute inset-0 flex items-center justify-center bg-green-900 bg-opacity-40 opacity-0 group-hover:opacity-100 transition-all duration-300">
                        <router-link :to="{ path: `/member/${member.member_code}` }"
                            class="bg-green-900 text-white shadow-md py-2 px-4 rounded-full">
                            Show Details
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeTab: "", // Active tab name
            memberGroups: [], // Dynamic tab names
            members: {}, // Member data grouped by type
        };
    },
    async created() {
        await this.fetchMembers();
    },
    methods: {
        async fetchMembers() {
            try {
                // Fetch the member list from the API
                const response = await fetch(`${this.$root.$data.BASE_URL}/api/member/list`);
                const data = await response.json();

                // Extract member groups and set default tab
                this.memberGroups = Object.keys(data);
                this.activeTab = this.memberGroups[0];

                // Store members data
                this.members = data;
            } catch (error) {
                console.error("Error fetching members:", error);
            }
        },
    },
};
</script>

<style scoped>
button {
    cursor: pointer;
    transition: all 0.3s ease;
}

button:hover {
    text-decoration: underline;
}

.member-card {
    position: relative;
    transition: transform 0.3s ease;
}

.member-card:hover {
    transform: translateY(-5px);
}

img {
    transition: transform 0.3s ease;
}

img:hover {
    transform: scale(1.05);
}

h1 {
    color: #2d6a4f;
}

h2 {
    color: #2d6a4f;
}
</style>
